export const createDataCloneError = () => new DOMException('', 'DataCloneError');
//# sourceMappingURL=data-clone-error.js.map